export const TRANSLATIONS = {
  English: {
    // Sidebar Groups & Items
    'nav.group.clinical_ops': 'Clinical Operations',
    'nav.group.vbc_ops': 'Value-Based Care & Ops',
    'nav.group.governance': 'Governance & Admin',
    'nav.care_intelligence': 'Care Intelligence',
    'nav.patient_roster': 'Patient Roster',
    'nav.clinical_tasks': 'Clinical Tasks',
    'nav.care_journeys': 'Care Journeys',
    'nav.risk_intelligence': 'Risk Intelligence',
    'nav.care_options': 'Care Options',
    'nav.messages': 'Messages',
    'nav.documents': 'Documents',
    'nav.coding_worklist': 'Coding Worklist',
    'nav.sub.worklist_queue': 'Worklist Queue',
    'nav.sub.suspect_workbench': 'Suspect Workbench',
    'nav.executive_dashboards': 'Executive Dashboards',
    'nav.sub.pmpm_financials': 'PMPM Financials',
    'nav.sub.quality_star': 'Quality & Star Ratings',
    'nav.provider_directory': 'Provider Directory',
    'nav.ride_booking': 'Ride Booking (NEMT)',
    'nav.ai_chat': 'Arc-8 AI Chat',
    'nav.role_privileges': 'Role & Privileges',
    'nav.master_admin': 'Master Admin',
    'nav.platform_settings': 'Platform Settings',
    'nav.sub.general_profile': 'General Profile',
    'nav.sub.security_hipaa': 'Security & HIPAA',
    'nav.sub.fhir_integrations': 'FHIR Integrations',
    'sidebar.hipaa_compliant': 'HIPAA Compliant',
    'sidebar.switch_role': 'Switch Role ▾',
    'sidebar.switch_persona_title': 'Switch Clinical Persona',
    'sidebar.switch_persona_desc': 'Select a persona to immediately preview role-specific clinical permissions.',
    'sidebar.cancel': 'Cancel',

    // Utility Bar
    'utility.quick_links': 'Quick links',
    'utility.switch_tenant': 'Switch tenant',
    'utility.notifications': 'Notifications',
    'utility.no_alerts': "No alerts — you're all caught up!",
    'utility.recent_activity': 'Recent activity',
    'utility.role': 'Role',
    'utility.roles_privileges': 'Roles & Privileges',
    'utility.profile_preferences': 'Profile & preferences',
    'utility.open_command_palette': 'Open command palette',
    'utility.log_out': 'Log out',

    // Settings Page
    'settings.eyebrow': 'Settings',
    'settings.title': 'Manage your Arc-8 preferences',
    'settings.subtitle': 'Personalize your workspace, navigation, and notifications.',
    'settings.kpi.role': 'Role',
    'settings.kpi.access_level': 'Access level',
    'settings.kpi.sections': 'Sections',
    'settings.kpi.available': 'Available',
    'settings.kpi.memories': 'Memories',
    'settings.kpi.saved': 'Saved',
    'settings.kpi.theme': 'Theme',
    'settings.kpi.current': 'Current',
    'settings.sections_header': 'Sections',
    'settings.tab.privileges': 'Roles & Privileges',
    'settings.tab.general': 'General',
    'settings.tab.data': 'Data controls',
    'settings.tab.personalization': 'Personalization',
    'settings.tab.memory': 'Memory',
    'settings.tab.notifications': 'Notifications',
    'settings.tab.beta': 'Beta features',
    'settings.tab.about': 'About',
    'settings.tab.navigation': 'Navigation',
    'settings.general.title': 'General',
    'settings.general.subtitle': 'Theme and language preferences.',
    'settings.general.theme_label': 'Theme',
    'settings.general.theme_desc': 'Choose system, light, or dark',
    'settings.general.language_label': 'Language',
    'settings.data.title': 'Data controls',
    'settings.data.subtitle': 'Export, clear, or delete your data.',
    'settings.data.export': 'Export data',
    'settings.data.clear_chat': 'Clear chat history',
    'settings.data.delete_account': 'Delete account',

    // Portal Overview Page
    'portal.eyebrow': 'Enterprise Clinical Portal',
    'portal.welcome_back': 'Welcome back',
    'portal.kpi.applications': 'Applications',
    'portal.kpi.available_to_you': 'Available to you',
    'portal.kpi.open_tasks': 'Open tasks',
    'portal.kpi.across_products': 'Across products',
    'portal.kpi.saved_items': 'Saved items',
    'portal.kpi.recently_pinned': 'Recently pinned',
    'portal.kpi.tenant': 'Tenant',
    'portal.kpi.workspace': 'Workspace',
    'portal.quick_search.title': 'Member quick search',
    'portal.quick_search.subtitle': 'Open a chart without leaving the portal.',
    'portal.last_saved.title': 'Last saved',
    'portal.last_saved.subtitle': 'Recent items you have pinned or updated.',
  },
  Spanish: {
    // Sidebar Groups & Items
    'nav.group.clinical_ops': 'Operaciones Clínicas',
    'nav.group.vbc_ops': 'Atención Basada en Valor y Ops',
    'nav.group.governance': 'Gobernanza y Administración',
    'nav.care_intelligence': 'Inteligencia de Atención',
    'nav.patient_roster': 'Padrón de Pacientes',
    'nav.clinical_tasks': 'Tareas Clínicas',
    'nav.care_journeys': 'Rutas de Atención',
    'nav.risk_intelligence': 'Inteligencia de Riesgos',
    'nav.care_options': 'Opciones de Atención',
    'nav.messages': 'Mensajes',
    'nav.documents': 'Documentos',
    'nav.coding_worklist': 'Lista de Codificación',
    'nav.sub.worklist_queue': 'Cola de Trabajo',
    'nav.sub.suspect_workbench': 'Mesa de Sospechas HCC',
    'nav.executive_dashboards': 'Paneles Ejecutivos',
    'nav.sub.pmpm_financials': 'Finanzas PMPM',
    'nav.sub.quality_star': 'Calidad y Calificación Estrella',
    'nav.provider_directory': 'Directorio de Proveedores',
    'nav.ride_booking': 'Reserva de Transporte (NEMT)',
    'nav.ai_chat': 'Chat IA Arc-8',
    'nav.role_privileges': 'Roles y Privilegios',
    'nav.master_admin': 'Administración Maestra',
    'nav.platform_settings': 'Configuración de Plataforma',
    'nav.sub.general_profile': 'Perfil General',
    'nav.sub.security_hipaa': 'Seguridad y HIPAA',
    'nav.sub.fhir_integrations': 'Integraciones FHIR',
    'sidebar.hipaa_compliant': 'Cumple con HIPAA',
    'sidebar.switch_role': 'Cambiar Rol ▾',
    'sidebar.switch_persona_title': 'Cambiar Persona Clínica',
    'sidebar.switch_persona_desc': 'Seleccione un perfil para previsualizar los permisos clínicos del rol.',
    'sidebar.cancel': 'Cancelar',

    // Utility Bar
    'utility.quick_links': 'Enlaces rápidos',
    'utility.switch_tenant': 'Cambiar organización',
    'utility.notifications': 'Notificaciones',
    'utility.no_alerts': 'Sin alertas — ¡estás al día!',
    'utility.recent_activity': 'Actividad reciente',
    'utility.role': 'Rol',
    'utility.roles_privileges': 'Roles y Privilegios',
    'utility.profile_preferences': 'Perfil y preferencias',
    'utility.open_command_palette': 'Abrir paleta de comandos',
    'utility.log_out': 'Cerrar sesión',

    // Settings Page
    'settings.eyebrow': 'Configuración',
    'settings.title': 'Administre sus preferencias de Arc-8',
    'settings.subtitle': 'Personalice su espacio de trabajo, navegación y notificaciones.',
    'settings.kpi.role': 'Rol',
    'settings.kpi.access_level': 'Nivel de acceso',
    'settings.kpi.sections': 'Secciones',
    'settings.kpi.available': 'Disponibles',
    'settings.kpi.memories': 'Memorias',
    'settings.kpi.saved': 'Guardadas',
    'settings.kpi.theme': 'Tema',
    'settings.kpi.current': 'Actual',
    'settings.sections_header': 'Secciones',
    'settings.tab.privileges': 'Roles y Privilegios',
    'settings.tab.general': 'General',
    'settings.tab.data': 'Controles de datos',
    'settings.tab.personalization': 'Personalización',
    'settings.tab.memory': 'Memoria',
    'settings.tab.notifications': 'Notificaciones',
    'settings.tab.beta': 'Funciones beta',
    'settings.tab.about': 'Acerca de',
    'settings.tab.navigation': 'Navegación',
    'settings.general.title': 'General',
    'settings.general.subtitle': 'Preferencias de tema e idioma.',
    'settings.general.theme_label': 'Tema',
    'settings.general.theme_desc': 'Elija sistema, claro u oscuro',
    'settings.general.language_label': 'Idioma',
    'settings.data.title': 'Controles de datos',
    'settings.data.subtitle': 'Exporte, borre o elimine sus datos.',
    'settings.data.export': 'Exportar datos',
    'settings.data.clear_chat': 'Borrar historial de chat',
    'settings.data.delete_account': 'Eliminar cuenta',

    // Portal Overview Page
    'portal.eyebrow': 'Portal Clínico Empresarial',
    'portal.welcome_back': 'Bienvenido de nuevo',
    'portal.kpi.applications': 'Aplicaciones',
    'portal.kpi.available_to_you': 'Disponibles para usted',
    'portal.kpi.open_tasks': 'Tareas abiertas',
    'portal.kpi.across_products': 'En todos los módulos',
    'portal.kpi.saved_items': 'Elementos guardados',
    'portal.kpi.recently_pinned': 'Fijados recientemente',
    'portal.kpi.tenant': 'Organización',
    'portal.kpi.workspace': 'Espacio de trabajo',
    'portal.quick_search.title': 'Búsqueda rápida de miembros',
    'portal.quick_search.subtitle': 'Abra un expediente sin salir del portal.',
    'portal.last_saved.title': 'Guardados recientemente',
    'portal.last_saved.subtitle': 'Elementos recientes que ha fijado o actualizado.',
  },
  French: {
    // Sidebar Groups & Items
    'nav.group.clinical_ops': 'Opérations Cliniques',
    'nav.group.vbc_ops': 'Soins Basés sur la Valeur & Ops',
    'nav.group.governance': 'Gouvernance & Administration',
    'nav.care_intelligence': 'Intelligence Clinique',
    'nav.patient_roster': 'Registre des Patients',
    'nav.clinical_tasks': 'Tâches Cliniques',
    'nav.care_journeys': 'Parcours de Soins',
    'nav.risk_intelligence': 'Intelligence des Risques',
    'nav.care_options': 'Options de Soins',
    'nav.messages': 'Messages',
    'nav.documents': 'Documents',
    'nav.coding_worklist': 'Liste de Codage',
    'nav.sub.worklist_queue': "File d'Attente",
    'nav.sub.suspect_workbench': 'Atelier des Suspects HCC',
    'nav.executive_dashboards': 'Tableaux de Bord Exécutifs',
    'nav.sub.pmpm_financials': 'Finances PMPM',
    'nav.sub.quality_star': 'Qualité & Étoiles',
    'nav.provider_directory': 'Annuaire des Prestataires',
    'nav.ride_booking': 'Transport Médical (NEMT)',
    'nav.ai_chat': 'Chat IA Arc-8',
    'nav.role_privileges': 'Rôles & Privilèges',
    'nav.master_admin': 'Administration Principale',
    'nav.platform_settings': 'Paramètres de la Plateforme',
    'nav.sub.general_profile': 'Profil Général',
    'nav.sub.security_hipaa': 'Sécurité & HIPAA',
    'nav.sub.fhir_integrations': 'Intégrations FHIR',
    'sidebar.hipaa_compliant': 'Conforme HIPAA',
    'sidebar.switch_role': 'Changer de Rôle ▾',
    'sidebar.switch_persona_title': 'Changer de Profil Clinique',
    'sidebar.switch_persona_desc': 'Sélectionnez un profil pour prévisualiser les autorisations associées.',
    'sidebar.cancel': 'Annuler',

    // Utility Bar
    'utility.quick_links': 'Liens rapides',
    'utility.switch_tenant': "Changer d'organisation",
    'utility.notifications': 'Notifications',
    'utility.no_alerts': 'Aucune alerte — tout est à jour !',
    'utility.recent_activity': 'Activité récente',
    'utility.role': 'Rôle',
    'utility.roles_privileges': 'Rôles & Privilèges',
    'utility.profile_preferences': 'Profil & préférences',
    'utility.open_command_palette': 'Ouvrir la palette de commandes',
    'utility.log_out': 'Se déconnecter',

    // Settings Page
    'settings.eyebrow': 'Paramètres',
    'settings.title': 'Gérez vos préférences Arc-8',
    'settings.subtitle': 'Personnalisez votre espace de travail, la navigation et les notifications.',
    'settings.kpi.role': 'Rôle',
    'settings.kpi.access_level': "Niveau d'accès",
    'settings.kpi.sections': 'Sections',
    'settings.kpi.available': 'Disponibles',
    'settings.kpi.memories': 'Mémoires',
    'settings.kpi.saved': 'Enregistrées',
    'settings.kpi.theme': 'Thème',
    'settings.kpi.current': 'Actuel',
    'settings.sections_header': 'Sections',
    'settings.tab.privileges': 'Rôles & Privilèges',
    'settings.tab.general': 'Général',
    'settings.tab.data': 'Contrôle des données',
    'settings.tab.personalization': 'Personnalisation',
    'settings.tab.memory': 'Mémoire',
    'settings.tab.notifications': 'Notifications',
    'settings.tab.beta': 'Fonctions bêta',
    'settings.tab.about': 'À propos',
    'settings.tab.navigation': 'Navigation',
    'settings.general.title': 'Général',
    'settings.general.subtitle': 'Préférences de thème et de langue.',
    'settings.general.theme_label': 'Thème',
    'settings.general.theme_desc': 'Choisissez système, clair ou sombre',
    'settings.general.language_label': 'Langue',
    'settings.data.title': 'Contrôle des données',
    'settings.data.subtitle': 'Exportez, effacez ou supprimez vos données.',
    'settings.data.export': 'Exporter les données',
    'settings.data.clear_chat': "Effacer l'historique du chat",
    'settings.data.delete_account': 'Supprimer le compte',

    // Portal Overview Page
    'portal.eyebrow': 'Portail Clinique Entreprise',
    'portal.welcome_back': 'Bon retour',
    'portal.kpi.applications': 'Applications',
    'portal.kpi.available_to_you': 'À votre disposition',
    'portal.kpi.open_tasks': 'Tâches ouvertes',
    'portal.kpi.across_products': 'Tous modules confondus',
    'portal.kpi.saved_items': 'Éléments enregistrés',
    'portal.kpi.recently_pinned': 'Épinglés récemment',
    'portal.kpi.tenant': 'Organisation',
    'portal.kpi.workspace': 'Espace de travail',
    'portal.quick_search.title': 'Recherche rapide de membre',
    'portal.quick_search.subtitle': 'Ouvrez un dossier sans quitter le portail.',
    'portal.last_saved.title': 'Récemment enregistrés',
    'portal.last_saved.subtitle': 'Éléments récents que vous avez épinglés ou mis à jour.',
  },
};

const ENGLISH_VALUE_TO_KEY = Object.entries(TRANSLATIONS.English).reduce((acc, [k, v]) => {
  acc[v] = k;
  return acc;
}, {});

export const translateText = (language, key, fallback = '') => {
  const dict = TRANSLATIONS[language] || TRANSLATIONS.English;
  if (dict[key]) return dict[key];
  const mappedKey = ENGLISH_VALUE_TO_KEY[key];
  if (mappedKey && dict[mappedKey]) return dict[mappedKey];
  return TRANSLATIONS.English[key] || fallback || key;
};
